import leticiaNeoSoul from "./leticia-neo-soul.mp4";
import asatocontestDarrylSyms from "./asatocontest-darryl-syms.mp4";

export const videoSamples = [
  {
    name: "Asato Contest Darryl Syms",
    source: asatocontestDarrylSyms,
  },
  {
    name: "Leticia Filizzola NeoSoul",
    source: leticiaNeoSoul,
  },
];
